import QRCode from 'react-qr-code';

export interface QRCodeDisplayProps {
  address: string;
  size?: number;
}

export default function QRCodeDisplay({ address, size = 200 }: QRCodeDisplayProps) {
  return (
    <div style={{ padding: 2, background: 'white', borderRadius: 8 }}>
      <QRCode value={address} size={size} />
    </div>
  );
}
